
 



 
 import {fs} from "Config/FsConfig";
 
    import ManageUserGroupMemberSearchParameter from 'Modules/Core/Scripts/AppServiceContract/ManageUserGroupMemberSearchParameter';

    import UserData01 from 'Modules/Core/Scripts/AppServiceContract/UserData01';

    import UserCriteria01 from 'Modules/Core/Scripts/UserCriteria01';

    import UserUpdateRequest from 'Modules/Core/Scripts/AppServiceContract/UserUpdateRequest';

    import ImportRequest from 'Modules/Core/Scripts/AppServiceContract/ImportRequest';

    import UserProfile from 'Modules/Core/Scripts/UserProfile';

    import LoginTypeData from 'Modules/Core/Scripts/AppServiceContract/LoginTypeData';


    //module ManageUserAppService {
    class ManageUserAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ManageUserAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ManageUserAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(parameter: ManageUserGroupMemberSearchParameter): JQuery.jqXHR<UserData01[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(criteria: UserCriteria01): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?userUID=${encodeURIComponent(userUID)}
    //public static RouteRemove = (userUID: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Remove`;
    public RouteRemove(userUID: string) : string {
        return this.ControllerUrl + "/"+"Remove";
    }
    public Remove(userUID: string): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteRemove(userUID),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(userUID),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?userUID=${encodeURIComponent(userUID)}
    //public static RouteLoad = (userUID: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Load`;
    public RouteLoad(userUID: string) : string {
        return this.ControllerUrl + "/"+"Load";
    }
    public Load(userUID: string): JQuery.jqXHR<UserData01> {
        return $.ajax({
                url: this.RouteLoad(userUID),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(userUID),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteUpdate = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Update`;
    public RouteUpdate() : string {
        return this.ControllerUrl + "/"+"Update";
    }
    public Update(request: UserUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteUpdate(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAdd = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Add`;
    public RouteAdd() : string {
        return this.ControllerUrl + "/"+"Add";
    }
    public Add(request: UserUpdateRequest): JQuery.jqXHR<string> {
        return $.ajax({
                url: this.RouteAdd(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?textInput=${encodeURIComponent(textInput)}
    //public static RouteFindUserAutoCompleteData = (textInput: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/FindUserAutoCompleteData`;
    public RouteFindUserAutoCompleteData(textInput: string) : string {
        return this.ControllerUrl + "/"+"FindUserAutoCompleteData";
    }
    public FindUserAutoCompleteData(textInput: string): JQuery.jqXHR<UserData01[]> {
        return $.ajax({
                url: this.RouteFindUserAutoCompleteData(textInput),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(textInput),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteImport = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/Import`;
    public RouteImport() : string {
        return this.ControllerUrl + "/"+"Import";
    }
    public Import(importRequest: ImportRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteImport(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(importRequest),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteRetrieveUserProfile = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/RetrieveUserProfile`;
    public RouteRetrieveUserProfile() : string {
        return this.ControllerUrl + "/"+"RetrieveUserProfile";
    }
    public RetrieveUserProfile(): JQuery.jqXHR<UserProfile> {
        return $.ajax({
                url: this.RouteRetrieveUserProfile(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindLoginType = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserAppService/FindLoginType`;
    public RouteFindLoginType() : string {
        return this.ControllerUrl + "/"+"FindLoginType";
    }
    public FindLoginType(): JQuery.jqXHR<LoginTypeData[]> {
        return $.ajax({
                url: this.RouteFindLoginType(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ManageUserAppService;



